// extracted by mini-css-extract-plugin
module.exports = {"policy":"PrivacyPolicy-module__policy___LyWOI","header":"PrivacyPolicy-module__header___OjgfB"};